import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { MenuItem, ListItemText, Button, Popover, Box, TextField, InputAdornment, Divider, Stack } from '@mui/material';
import _ from 'lodash';
import SearchIcon from '../assets/search.icon';
import { DataType, Order, OrderBy } from '../types';

export type SelectedList = { name: string; value: string }[];

type selectorProps = {
	options: SelectedList;
	listHandleChange?: (list: SelectedList) => void;
	termSearchHandleChange?: (term: string) => void;
	sorthHandleChange?: (order: Order) => void;
	handleClose: () => void;
	open?: boolean;
	anchorEl: any;
	columnType: DataType;
};

export const MenuFilter: React.FC<selectorProps> = ({
	options,
	listHandleChange,
	termSearchHandleChange,
	sorthHandleChange,
	open = false,
	anchorEl,
	handleClose,
	columnType,
}: selectorProps) => {
	const [selected, setSelected] = React.useState<{ name: string; value: string }[]>([]);
	const [term, setTerm] = React.useState<string>('');
	const id = open ? 'simple-popover' : undefined;

	const onHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const checked = event.target.checked;
		const name = event.target.name;
		const option = { name: name, value: event.target.value };
		let selecting: SelectedList = [];

		if (name === 'all') {
			selecting = !checked ? [] : options;
		} else {
			selecting = checked ? [...selected, option] : _.filter(selected, (option) => option.name !== name);
		}
		setSelected(selecting);
		if (listHandleChange) {
			const final = options.length === selecting.length ? [] : selecting;
			listHandleChange(final);
		}
	};

	const termSearchOnChange = (event: any) => {
		setTerm(event.target.value);
		if (termSearchHandleChange) {
			termSearchHandleChange(event.target.value);
		}
	};

	const sorthHandleOnChange = (order: Order) => {
		if (sorthHandleChange) {
			sorthHandleChange(order);
		}
	};

	const resetFilter = () => {
		setSelected([]);
		if (listHandleChange) {
			listHandleChange([]);
		}
		setTerm('');
		if (termSearchHandleChange) {
			termSearchHandleChange('');
		}
	};

	const isAllSelected = options.length > 0 && selected.length === options.length;

	return (
		<Box>
			<Popover
				id={id}
				className="BasicTable-TableMenuFilter"
				sx={{
					'& .MuiPaper-root': {
						padding: '8px',
						'& .MuiInputBase-root': {
							height: '40px',
						},
					},
				}}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
			>
				<Stack spacing={1}>
					<a onClick={() => sorthHandleOnChange('desc')} style={{ cursor: 'pointer' }}>
						מיון A - Z
					</a>
					<a onClick={() => sorthHandleOnChange('asc')} style={{ cursor: 'pointer' }}>
						מיון Z - A
					</a>
					<Divider />
					<a onClick={() => resetFilter()} style={{ cursor: 'pointer' }}>
						אפס את כל המסנן
					</a>
					<Divider />
					<TextField
						placeholder="search"
						onChange={termSearchOnChange}
						value={term}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon />
								</InputAdornment>
							),
						}}
					/>
					<Box className="BasicTable-MenuFilterList">
						<MenuItem value="all">
							<Checkbox
								name="all"
								onChange={onHandleChange}
								checked={isAllSelected}
								indeterminate={selected.length > 0 && selected.length < options.length}
							/>
							<ListItemText primary="Select All" />
						</MenuItem>
						{options.map((option) => (
							<MenuItem key={option.name} value={option.value}>
								<Checkbox
									name={option.name}
									value={option.value}
									onChange={onHandleChange}
									checked={!_.isEmpty(_.find(selected, option))}
								/>
								<ListItemText primary={option.name} />
							</MenuItem>
						))}
					</Box>
				</Stack>
			</Popover>
		</Box>
	);
};
